import { FC } from 'react';

type Props = {
	className?: string;
};

const ChartBarLineIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='inherit'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M4.18041 11.4546C4.58208 11.4546 4.9077 11.7802 4.9077 12.1819V15.091C4.9077 15.4927 4.58208 15.8183 4.18041 15.8183C3.77875 15.8183 3.45312 15.4927 3.45312 15.091V12.1819C3.45312 11.7802 3.77875 11.4546 4.18041 11.4546Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.0007 7.09082C10.4024 7.09082 10.728 7.41644 10.728 7.81811V15.091C10.728 15.4927 10.4024 15.8183 10.0007 15.8183C9.59904 15.8183 9.27344 15.4927 9.27344 15.091V7.81811C9.27344 7.41644 9.59904 7.09082 10.0007 7.09082Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M18.0003 17.2727C18.0003 17.6744 17.6747 18 17.273 18H2.72729C2.32561 18 2 17.6744 2 17.2727C2 16.871 2.32561 16.5454 2.72729 16.5454H17.273C17.6747 16.5454 18.0003 16.871 18.0003 17.2727Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15.8171 10C16.2188 10 16.5444 10.3256 16.5444 10.7273V15.091C16.5444 15.4927 16.2188 15.8183 15.8171 15.8183C15.4154 15.8183 15.0898 15.4927 15.0898 15.091V10.7273C15.0898 10.3256 15.4154 10 15.8171 10Z'
				fill='inherit'
			/>
			<path
				d='M7.81829 4.18186C7.81829 2.97685 8.79511 2 10.0002 2C11.2052 2 12.182 2.97685 12.182 4.18186C12.182 4.27299 12.1764 4.36295 12.1654 4.45138L14.3039 5.5206C14.6959 5.14246 15.2296 4.90915 15.8184 4.90915C17.0235 4.90915 18.0003 5.88599 18.0003 7.09101C18.0003 8.29601 17.0235 9.27287 15.8184 9.27287C14.6134 9.27287 13.6366 8.29601 13.6366 7.09101C13.6366 6.99987 13.6422 6.90991 13.6532 6.82149L11.5147 5.75226C11.1227 6.13041 10.589 6.36372 10.0002 6.36372C9.55272 6.36372 9.13672 6.22873 8.79075 5.998L6.26423 7.89291C6.32886 8.09921 6.36372 8.31855 6.36372 8.54558C6.36372 9.75062 5.38686 10.7274 4.18186 10.7274C2.97685 10.7274 2 9.75062 2 8.54558C2 7.34057 2.97685 6.36372 4.18186 6.36372C4.62931 6.36372 5.04532 6.49871 5.39124 6.72944L7.91778 4.83453C7.85315 4.62822 7.81829 4.40889 7.81829 4.18186Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default ChartBarLineIconSolid;
